import { TemConnectionBodySteps } from '../tem-connection-modal-body/temConnectionModalBody.model';

export function getModalCurrentStep({
  isConnecting,
  isFailure,
  isNotAllowed,
  isSuccess,
  isRefusedByUser,
}: {
  readonly isConnecting: boolean;
  readonly isFailure: boolean;
  readonly isNotAllowed: boolean;
  readonly isSuccess: boolean;
  readonly isRefusedByUser: boolean;
}): TemConnectionBodySteps {
  if (isConnecting) {
    return TemConnectionBodySteps.Connecting;
  } else if (isFailure) {
    return TemConnectionBodySteps.Failure;
  } else if (isNotAllowed) {
    return TemConnectionBodySteps.NotAllowed;
  } else if (isSuccess) {
    return TemConnectionBodySteps.Success;
  } else if (isRefusedByUser) {
    return TemConnectionBodySteps.RefusedByCustomer;
  } else {
    return TemConnectionBodySteps.Connecting;
  }
}
